<template>
  <div class="ee-editor">
    <div class="ee-editor-container">
      <div
        style="margin: 0; margin-bottom: 16px;"
        class="map-editor__controls"
        v-if="state.history.length"
      >
        <el-button
          class="r-button map-editor__controls-button"
          :loading="state.loading"
          size="small"
          type="success"
          @click="saveData"
        >
          Сохранить изменения
        </el-button>
      </div>

      <mode-switcher :state="state" @toggle-editor-mode="toggleEditorMode" />
      <event-type-select
        v-if="state.mode === 'create'"
        :state="state"
        @toggle-geometry-mode="toggleGeometryMode"
      />

      <editor-history
        style="margin-top: 16px;"
        :editor-state="state"
        @change-history-step="changeHistoryStep"
        @clear-editing-state="clearEditingState"
      />
    </div>

    <ee-help :state="state" />
  </div>
</template>

<script>
import ModeSwitcher from "./editor/mode-switcher";
import EventTypeSelect from "./editor/event-type-select";
import EditorHistory from "@/components/map/components/map-editor/editor-history";
import EeHelp from "./editor/help";

export default {
  props: ["map", "draw", "state", "mode", "controller"],
  components: {
    ModeSwitcher,
    EventTypeSelect,
    EditorHistory,
    EeHelp
  },
  methods: {
    toggleEditorMode(mode) {
      this.controller.toggleEditorMode(mode);
    },
    toggleGeometryMode(mode) {
      const value = `draw_${mode}`;

      this.controller.changeGeometryMode(value);
    },
    changeHistoryStep(type) {
      this.controller.changeHistoryStep(type);
    },
    clearEditingState() {
      this.controller.clearEditingState();
    },
    saveData() {
      this.controller.saveData();
    }
  }
};
</script>

<style lang="scss">
.ee-editor {
  display: flex;
  flex-direction: column;
  flex: 1;

  &-container {
    padding: 16px;
    flex: 1;
  }

  .map-editor-mode {
    margin-top: 0;
  }
}
</style>
